module.exports = "https://web-assets.ifttt.com/packs/media/premium_insights/arrow-down-344b9cf9.svg";